<form [formGroup]="materialRatesFilterForm" class="filter-form-vertical">
  <div class="form-content">
    <!-- LOCATION FILTERS (GSC users only): Region, Cluster, Country, Shop -->
    @if (isGSCUser) {
      <div class="location-filter-wrapper" #locationWrapper>
        <app-location-filter [isGSCUser]="isGSCUser" [allShops]="allShops" (shopCodesChange)="onShopCodesChange($event)">
        </app-location-filter>
      </div>
    }

    <!-- REPAIR MODE -->
    <div>
      <mc-typeahead-multi-select
        #repairModeSelect
        label="Repair Mode"
        placeholder="Type or select repair mode"
        fit="medium"
        width="100%"
        name="repairMode"
        [data]="repairModeTypeaheadData"
        [selecteddata]="selectedRepairModes"
        (optionselected)="onRepairModeSelected($event)"
        (clearbuttonclick)="onRepairModeCleared()"
        (search)="onRepairModeSearch($event)"
        (focus)="onRepairModeDropdownOpen()">
      </mc-typeahead-multi-select>
    </div>

    <!-- REPAIR CODE -->

    <div>
      <mc-typeahead-multi-select
        #repairCodeSelect
        label="Repair Code"
        placeholder="Type or select repair code"
        fit="medium"
        maxoptions="100"
        width="100%"
        name="repairCode"
        [data]="repairCodeTypeaheadData"
        [selecteddata]="selectedRepairCodes"
        (optionselected)="onRepairCodeSelected($event)"
        (clearbuttonclick)="onRepairCodeCleared()"
        (search)="onRepairCodeSearch($event)"
        (focus)="onRepairCodeDropdownOpen()">
      </mc-typeahead-multi-select>
    </div>

    <!-- EXPIRY DATE & EFFECTIVE DATE FILTERS -->
    <div>
      <app-date-filter-row
        [formGroup]="materialRatesFilterForm"
        label="Expiry Date"
        typeControlName="expiryDateType"
        dateControlName="expiryDate"
        fromControlName="expiryDateFrom"
        toControlName="expiryDateTo"
        [options]="expiryDateTypes">
      </app-date-filter-row>

      <app-date-filter-row
        style="display: block; margin-top: 16px"
        [formGroup]="materialRatesFilterForm"
        label="Effective Date"
        typeControlName="effectiveDateType"
        dateControlName="effectiveDate"
        fromControlName="effectiveDateFrom"
        toControlName="effectiveDateTo"
        [options]="effectiveDateTypes">
      </app-date-filter-row>
    </div>
  </div>

  <!-- ACTION BUTTONS -->
  <div class="utility-buttons">
    <mc-button
      type="button"
      label="Apply Filters"
      slot="primaryAction"
      variant="filled"
      appearance="primary"
      fit="medium"
      (click)="applyFilters()"
      class="p-r-16">
    </mc-button>

    <mc-button
      type="button"
      label="Clear Filters"
      slot="secondaryAction"
      appearance="neutral"
      fit="medium"
      (click)="clearFilters()"
      class="p-r-16">
    </mc-button>
  </div>
</form>
